﻿document.addEventListener('DOMContentLoaded', () => {
    // Select the anchor link and scroll to element
    const anchorLink = document.querySelector('a[href="#anchor"]');
    const anchorEl = document.getElementById('anchor');

    if (anchorLink && anchorEl) {
        // Add click event listener to the anchor link
        anchorLink.addEventListener('click', (event) => {
            event.preventDefault(); // Prevent default link behavior

            const targetPosition = anchorEl.getBoundingClientRect().top + window.scrollY - 52;
            const startPosition = window.scrollY;
            const distance = targetPosition - startPosition;
            const duration = 300; // Change this value to control the duration in milliseconds
            let startTime = null;

            // Function to regulate scroll animation
            function scrollAnimation(currentTime) {
                if (startTime === null) startTime = currentTime;
                const timeElapsed = currentTime - startTime;
                const scrollAmount = Math.easeInOutQuad(timeElapsed, startPosition, distance, duration);
                window.scrollTo(0, scrollAmount);
                if (timeElapsed < duration) requestAnimationFrame(scrollAnimation);
            }

            // Easing function for smooth acceleration and deceleration
            Math.easeInOutQuad = function (t, b, c, d) {
                t /= d / 2;
                if (t < 1) return c / 2 * t * t + b;
                t--;
                return -c / 2 * (t * (t - 2) - 1) + b;
            };

            requestAnimationFrame(scrollAnimation);
        });
    }
});
